import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Router} from "@angular/router";

import {NgClass} from '@angular/common';
import {MenuItem} from '../../../core/models/menu/menu-item';
import {MenuItemsContainer} from './menu-items-container';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: "app-menu-item",
  imports: [
    NgClass,
    TranslatePipe,
  ],
  templateUrl: "./menu-item.component.html",
  styleUrls: ["./menu-item.component.css"]
})
export class MenuItemComponent {

  @Input() navItem: MenuItem;
  @Output() menuClickEvent = new EventEmitter<void>();

  constructor(private router: Router) {
  }

  onClick(): void {
    this.menuClickEvent.emit();
  }

  isOnPage() {
    return MenuItemsContainer.isSelectedMenuItem(this.router.url, this.navItem);
  }

  public getDataStyle(style: string): string {
    const SELECTED_SUFFIX = "-selected";
    const navItemPath = this.navItem.path;

    if (!navItemPath) {
      return style;
    }

    return this.isOnPage() ? `${style}${SELECTED_SUFFIX}` : style;
  }

  public isActive(): boolean {
    const navItemPath = this.navItem.path;

    if (!navItemPath) {
      return false;
    }

    return this.isOnPage();
  }

  public getIcon(): string {
    return "url(assets/images/" + this.navItem.icon + ")";
  }

  getSubItemImage(): string {
    return this.navItem.open ? "assets/images/menu_close.png" : "assets/images/menu_open.png";
  }

}
